
import RouterConfig from './navigation';

const App = () => {
  return <RouterConfig />;

};


export default App;


// import Header from "./components/Header"
// import Hero from "./components/Hero"
// import Approach from "./components/Approach"
// import Portfolio from "./components/Portfolio"
// import Insights from "./components/Insights"
// import Footer from "./components/Footer"

// export default function App() {
//   return (
//     <div className="bg-background-light dark:bg-background-dark min-h-screen">
//       <Header />

//       <main>
//         <Hero />
//         <Approach />
//         <Portfolio />
//         <Insights />
//       </main>

//       <Footer />
//     </div>
//   )
// }